module.exports = ".table th {\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/raw-table/raw-table.component.scss
// module id = ./src/app/home/raw-table/raw-table.component.scss
// module chunks = main